import { apiClient } from "../../api/apiClient";
import type { TicketFormBody } from "./ticketForm/ticketFormOperations";
import type { Ticket } from "./ticketSharedTypes";

const RESOURCE = "communications/tickets";

// TODO: use generated api client here
export const createTicketRequest = (
  ticketBody: TicketFormBody,
  clientConfig = {},
) => {
  return apiClient(clientConfig).post<Ticket>(RESOURCE, ticketBody);
};

// TODO: use generated api client here
export const updateTicketAsync = (
  id: string,
  body: Partial<Ticket>,
  clientConfig = {},
) => {
  return apiClient(clientConfig).put<Ticket>(`${RESOURCE}/${id}`, body);
};

// TODO: use generated api client here
export const addMessageRequest = (
  id: number,
  content: string,
  attachments: File[] = [],
  clientConfig = {},
) => {
  return apiClient(clientConfig).post(`${RESOURCE}/${id}/messages`, {
    content,
    attachments,
  });
};
